import React, { useEffect } from "react";
import Sidebar from "./components/common/Sidebar";
import AuthIndex from "./screens/AuthIndex";
import MainIndex from "./screens/MainIndex";
import { ToastContainer } from "react-toastify";
import { AllContextProvider } from "./context/AllContext";
import { useLocation } from 'react-router-dom';

function App(props) {

  const location = useLocation();
  function activekey() {
    var res = window.location.pathname

    var baseUrl = process.env.PUBLIC_URL
    baseUrl = baseUrl.split("/");
    res = res.split("/");
    res = res.length > 0 ? res[baseUrl.length] : "/";
    res = res ? "/" + res : "/";;
    const activeKey1 = res;
    return activeKey1
  }
  useEffect(() => {
    activekey();
  }, [location.pathname]);

  console.log(activekey())

  if (activekey() === "/sign-in" || activekey() === "/client-login" || activekey() === "/super-login" || activekey() === "/sign-up" || activekey() === "/password-reset" || activekey() === "/2-step-authentication" || activekey() === "/page-404") {
    return (
      <div id="mytask-layout" className="theme-indigo">
        <ToastContainer />
        <AuthIndex />
      </div>
    )
  }
  return (
    <div id="mytask-layout" className="theme-indigo">
      <ToastContainer />
      <AllContextProvider>
        <Sidebar activekey={activekey()} history={props.history} />
        <MainIndex activekey={activekey()} />
      </AllContextProvider>
    </div>
  );
}


export default App;
